import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material'
import { nunaCorp1, nunaCorp2 } from 'assets'
import { LandingButton, NunaLabel } from 'components'
import { COLORS, IDEAL_USES_NUNA_CORP_CONST } from 'const'
import { motion } from 'framer-motion'
import { containerVariants, landingButtonPrimary, normalTextStyle, sliderBrandTitle } from 'styles'

const whatsappLink = process.env.REACT_APP_WHATSAPP_LINK!
export const NunaExpressCorpSection = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Box
      id="blog"
      component={motion.div}
      initial="offscreen"
      whileInView="onscreen"
      variants={containerVariants}
      viewport={{ once: true }}
    >
      <Box
        sx={{
          bgcolor: '#4363a2ff',
          px: { xs: 4, md: 13, lg: 30, xl: 15 },
          py: { xs: 8, md: 10, lg: 20 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
        }}
      >
        <Box
          component="img"
          src={nunaCorp1}
          alt={'Necesitar firmar un documento con urgencia y no cuentas con una firma electrónica?'}
          sx={{
            width: '100%',
            borderRadius: { xs: 5, md: 10, lg: 20 },
            maxHeight: { xs: 300, lg: 550 },
            objectFit: 'cover',
            fontSize: { xs: '1rem', md: '1rem', xl: '1.5rem' },
          }}
        />
        <Grid container spacing={2} my={1}>
          <Grid
            size={{ xs: 12, md: 5, xl: 5 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' },
              justifyContent: { sx: 'center', md: 'flex-start' },
            }}
          >
            <NunaLabel
              title="NUNA EXPRESS"
              sxImgProps={isMobile ? { width: 35, height: 35 } : {}}
              sxTextProps={isMobile ? { fontSize: '1.8rem' } : { fontSize: '3rem' }}
            />
            <Typography
              sx={{
                ...sliderBrandTitle,
                color: COLORS.text.white,
                lineHeight: 1,
                fontSize: { xs: '1.8rem', md: '2.75rem', xl: '3rem' },
              }}
            >
              corporativo
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, md: 7, xl: 7 }}>
            <Typography
              sx={{
                ...normalTextStyle,
                textAlign: { md: 'left', xs: 'center' },
                color: COLORS.text.white,
              }}
            >
              Integra el servicio de firma en tus canales digitales y ofrece a tus usuarios una
              experiencia ágil con Nuna Express. Tus usuarios pueden firmar documentos en segundos,
              gracias a nuestro proceso biométrico de validación de identidad, sin la necesidad de
              contar con una firma electrónica. Todas nuestras firmas están certificadas por
              ARCOTEL, asegurando su plena validez legal. En el ámbito corporativo, esto significa
              procesos más rápidos, seguros y eficientes, que se traducen en una mejor experiencia
              digital para ti y tus usuarios.
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          backgroundColor: '#32558bff',
          borderRadius: '50px 50px 0 0',
          mt: -5,
          px: { xs: 4, md: 13, lg: 30, xl: 15 },
          py: { xs: 8, md: 10, lg: 20 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
        }}
      >
        <Grid container spacing={{ xs: 5, lg: 10 }}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Typography
              variant="h4"
              sx={{ ...sliderBrandTitle, color: COLORS.text.white, fontWeight: 600, mb: 3 }}
            >
              Casos de uso por sector:
            </Typography>
            <Box
              component="img"
              src={nunaCorp2}
              alt={
                'Necesitar firmar un documento con urgencia y no cuentas con una firma electrónica?'
              }
              sx={{
                width: '100%',
                height: '90%',
                borderRadius: 10,
                objectFit: 'cover',
                fontSize: { xs: '1rem', md: '1rem', xl: '1.5rem' },
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }} mt={{ xs: 5 }}>
            {IDEAL_USES_NUNA_CORP_CONST.map((use) => (
              <Box key={use.title} sx={{ my: 2 }}>
                <Typography
                  sx={{ ...normalTextStyle, fontWeight: 'bold', color: COLORS.text.white }}
                >
                  {use.title}
                </Typography>
                <Typography
                  sx={{
                    ...normalTextStyle,
                    lineHeight: 1.25,
                    whiteSpace: 'pre-line',
                    color: COLORS.text.white,
                  }}
                >
                  {use.description}
                </Typography>
              </Box>
            ))}
            <LandingButton
              text={'COMIENZA AHORA'}
              style={{
                ...landingButtonPrimary,
                backgroundColor: COLORS.button.nuna,
                color: COLORS.text.black,
                borderRadius: '30px',
                mt: 2,
                px: {
                  xs: 3,
                  md: 4,
                },
                width: 'fit-content',
              }}
              onClick={() => {
                window.open(whatsappLink, '_blank')
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}
